<ion-card class="noEntriesCard">
  <ion-card-content>
    <ion-icon name="warning-outline"></ion-icon>
    <ion-card-title [innerHTML]="'no_entries'|translate"></ion-card-title>
  </ion-card-content>
</ion-card>